export const publicLandingPage = 'signup'
export const privateLandingPage = 'category'
export const specialPublicLandingPage = 'login'
